module.exports = __webpack_public_path__ + "assets/img/Asset4R.43c48690.png";